import { Action } from 'redux'
import { ReservationFormFieldVisibility } from '../../../containers/Form/CreateReservation/withReduxForm'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

export interface IToggleFieldVisibility
  extends Action<ReservationModalActions.ToggleFieldVisibility> {
  fieldName: keyof ReservationFormFieldVisibility
  value: boolean
}

export interface ISetFieldsVisibility
  extends Action<ReservationModalActions.SetFieldsVisibility> {
  value: ReservationFormFieldVisibility
}

export const toggleFieldVisibility = (
  fieldName,
  value,
): IToggleFieldVisibility => ({
  fieldName,
  type: ReservationModalActions.ToggleFieldVisibility,
  value,
})

export const setFieldsVisibility = (
  value: ReservationFormFieldVisibility,
): ISetFieldsVisibility => ({
  type: ReservationModalActions.SetFieldsVisibility,
  value,
})
